


import React, { useState } from 'react';
import Vendorcoustomercare from "../Food/Vendorcoustomercare";
import Usercoustomercare from "../Food/Usercoustomercare";
import { Link } from "react-router-dom";
// import DeliveryCare from "./DeliveryCare";
function Logisticscare() {
    const [activeView, setActiveView] = useState("user");

    // Style constants
    const activeColor = "#b15cd6";
    const inactiveColor = "#f0f2f5";
    const activeTextColor = "#ffffff";
    const inactiveTextColor = "#333333";
    const activeBorderColor = "#b15cd6";
    const inactiveBorderColor = "#ced4da";

    const commonButtonStyles = {
        padding: "0.5rem 0.5rem",
        borderRadius: "0.375rem",
        fontWeight: 600,
        borderWidth: "1px",
        borderStyle: "solid",
        cursor: "pointer",
        transition:
            "background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, color 0.15s ease-in-out",
        outline: "none",
        boxShadow: "none",
    };

    // Original margin for the container-fluid, potentially for a global page header or spacing.
    const pageWrapperMarginTopString = "35px";


    const contentEffectiveStartOffsetString = "80px"; // Using the original `topOffset` value


    const internalMarginTopValue =
        parseFloat(contentEffectiveStartOffsetString) - parseFloat(pageWrapperMarginTopString);
    const internalMarginTop = `${internalMarginTopValue}px`; // e.g., "45px"


    const mainFlexContainerHeight = `calc(100vh - ${contentEffectiveStartOffsetString})`;



    return (
        <div className="container-fluid p-0" style={{ marginTop: '85px' }}>
            <div className="row">
                <div className="col-lg-2"></div> {/* Sidebar or empty space */}
                <div className="col-lg-10 col-md-12 col-sm-12 col-12">

                    <p
                        className="breadcrumb maamaas-home-bredcum or7"
                        style={{
                            position: "fixed",
                            top: "25px",
                            left: "1vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            // zIndex: 1000,
                            padding: "42px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                            zIndex: "999",
                            height: "80px",
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Customercare_Management
                        </span>
                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Logistics & Supply
                        </span>
                    </p>
                    <div
                        style={{

                            marginTop: "25px", // Positions this block correctly within col-lg-10
                            height: mainFlexContainerHeight, // Ensures it fits the desired viewport portion
                        }}
                    >
                        {/* Button Bar Container */}
                        <div
                            className="d-flex justify-content-center row g-2" // Bootstrap class for centering buttons
                            style={{
                                // padding: "1rem 0", // Adds vertical spacing around the buttons
                                backgroundColor: "#ffffff", // Crucial for sticky; content won't show through
                                flexShrink: 0, // Prevents this bar from shrinking if content is sparse
                                position: "sticky",
                                top: 0, // Sticks to the top of its parent (the Main Flex Container)
                                zIndex: 10, // Ensures it stays above scrolling content
                                gap: "10px",
                                // borderBottom: '1px solid #e0e0e0', // Optional: if a visual separator is desired
                            }}
                        >

                            <button
                                type="button"
                                className="me-2 btn" // Bootstrap margin utility for spacing between buttons
                                style={{
                                    fontSize: "13px !important",
                                    width: "140px", // Fixed width for consistency
                                    ...commonButtonStyles,
                                    backgroundColor: activeView === "user" ? activeColor : inactiveColor,
                                    color: activeView === "user" ? activeTextColor : inactiveTextColor,
                                    borderColor: activeView === "user" ? activeBorderColor : inactiveBorderColor,
                                }}
                                onClick={() => setActiveView("user")}
                            >
                                User
                            </button>
                            <button
                                className="btn"
                                type="button"
                                style={{
                                    fontSize: "13px !important",
                                    width: "140px", // Fixed width for consistency
                                    ...commonButtonStyles,
                                    backgroundColor: activeView === "vendor" ? activeColor : inactiveColor,
                                    color: activeView === "vendor" ? activeTextColor : inactiveTextColor,
                                    borderColor: activeView === "vendor" ? activeBorderColor : inactiveBorderColor,
                                }}
                                onClick={() => setActiveView("vendor")}
                            >
                                Captain
                            </button>


                        </div>

                        {/* Scrollable Content Area */}
                        <div
                            style={{
                                flexGrow: 1,
                            }}
                        >
                            {activeView === "user" && <Usercoustomercare />}
                            {activeView === "vendor" && <Vendorcoustomercare />}
                            {/* {activeView === "delivery" && <DeliveryCare />} */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Logisticscare;